import { render, staticRenderFns } from "./ActiveTrip.vue?vue&type=template&id=ab1e88d8&"
import script from "./ActiveTrip.vue?vue&type=script&lang=js&"
export * from "./ActiveTrip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports